import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import GroupIcon from '@material-ui/icons/Group';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';

class GroupCard extends React.Component {

  selectGroup = () => this.props.onSelectGroup(this.props.data.id);

  render() {

    const { classes, data, isSelected } = this.props;

    return (
      <Card
        tabIndex={0}
        data-test={data.label.en}
        className={isSelected ? classes.gsSelectedCard : classes.gsCard}
        onKeyDown={(ev) => {
          if (ev.key === "Enter") {
            ev.preventDefault();
            ev.stopPropagation();
            this.selectGroup();
          }
        }}
        onClick={this.selectGroup}>
        <CardHeader
          data-test="group-name"
          classes={{
            root: classes.gsCardInner
          }}
          titleTypographyProps={{
            className: classes.gsCardHeader
          }}
          avatar={<Avatar className={classes.smallPrimaryAvatar}>
            <GroupIcon />
          </Avatar>
          }
          title={data.label.en}
        />
      </Card>
    );
  }
}

GroupCard.defaultProps = {
  isSelected: false
};

GroupCard.propTypes = {
  classes: PropTypes.object,
  isSelected: PropTypes.bool,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  onSelectGroup: PropTypes.func.isRequired
};

export default withStyles(styles)(withGS(GroupCard));